/**
 * PWA metadata, added at startup — but never on the guest menu domain.
 *
 * siply.pro and spiritvault.pro are served by this same app (see MenuDomainRedirect), so
 * a manifest linked statically in index.html would also sit on every QR-code menu. Guests
 * would then be offered to install "SpiritVault Pro", the staff app. The manifest is what
 * makes a browser show its install affordance, so leaving it off the menu domain is what
 * actually suppresses the offer there.
 *
 * This runs synchronously before React renders, so browsers see the final state when they
 * evaluate installability.
 */

/** Same rule as MenuDomainRedirect: env var first, hostname as fallback */
export function isMenuDomain(): boolean {
  if (typeof window === 'undefined') return false;
  const menuUrl = import.meta.env.VITE_MENU_URL;
  if (menuUrl) return window.location.origin === menuUrl;
  const host = window.location.hostname;
  return host === 'siply.pro' || host === 'www.siply.pro';
}

function addLink(rel: string, href: string) {
  if (document.querySelector(`link[rel="${rel}"]`)) return;
  const link = document.createElement('link');
  link.rel = rel;
  link.href = href;
  document.head.appendChild(link);
}

function addMeta(name: string, content: string) {
  if (document.querySelector(`meta[name="${name}"]`)) return;
  const meta = document.createElement('meta');
  meta.name = name;
  meta.content = content;
  document.head.appendChild(meta);
}

export function installPwaMetadata() {
  if (typeof document === 'undefined') return;
  if (isMenuDomain()) return;

  addLink('manifest', '/manifest.webmanifest');
  addLink('apple-touch-icon', '/apple-touch-icon.png');
  addMeta('apple-mobile-web-app-capable', 'yes');
  addMeta('mobile-web-app-capable', 'yes');
  addMeta('apple-mobile-web-app-status-bar-style', 'black-translucent');
  addMeta('apple-mobile-web-app-title', 'SpiritVault');
}

export default installPwaMetadata;
